/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_ORDERS (state, orders) {
    state.orders = orders
  },
  REMOVE_RECORD (state, itemId) {
    const userIndex = state.orders.findIndex((u) => u.id === itemId)
    state.orders.splice(userIndex, 1)
  },
  UPDATE_ORDER (state, order) {
    const orderIndex = state.orders.findIndex((p) => p._id === order.orderId)
    Object.assign(state.orders[orderIndex], order)
  }
}
